export const limit = 13;

export const profileCouponsTableLimit = 10;
